import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="h-dvh w-dvw bg-bg-grey p-4 text-black">
      <div className="mt-1">
        <div onClick={() => navigate(-1)}>
          <img src="/icons/backbtn.svg" alt="" />
        </div>
        <h6 className="text-20 font-bold text-black mx-auto flex-1 text-center">
          {t("contactUs")}
        </h6>
      </div>
      <div className="mt-5">
        <div className="mt-4">
          <div className="underline text-14">Legal Name</div>
          <div>Kalpanecha Karkhana Pvt. Ltd.</div>
        </div>
        <div className="mt-6">
          <div className="underline text-14">GST Number</div>
          <div>27AAKCK9567D1Z2</div>
        </div>
        <div className="mt-6">
          <div className="underline text-14">Kalpana Name</div>
          <div>Sangati</div>
        </div>
        <div className="mt-6 flex flex-col">
          <div className="underline text-14">{t("emailUs")}</div>
          <div className="flex gap-2">
            <div>
              <img src="/icons/email.svg" alt="" />
            </div>
            <div className="text-14">support@sangati.live</div>
          </div>
        </div>
        <div className="mt-6 flex flex-col">
          <div className="underline text-14">
            Write to us at our Registered and Operational Address:
          </div>
          <div className="flex gap-2 mt-2">
            <div>
              <img src="/icons/location.svg" alt="" />
            </div>
            <div className="text-14">
              124/7B Saraswati Apts, Fatellal Lane, Law College Road, <br />{" "}
              Pune, Maharashtra, <br /> India PIN: 411004
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
